/* eslint-disable */
import React from 'react';
import { Box } from '../../components/element';
import { GenericSelect } from '../../components/select';
import { getQueryStringValues, ChangeQueryString } from '../../utils/withPath';
import {
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_ALLETRA9k,
  PRODUCT_ID_ALLETRAB10K,
  PRODUCT_ID_BAAS_9K_M,
  PRIMERA_OPT_FACTORY,
  DHCI_OPT_GREEN,
  PRIMERA_OPT_FIELD,
  PRODUCT_ID_PCBE,
  HPE_SIMPLIVITY,
  PRODUCT_ID_FILE,
  PRODUCT_ID_OAAS,
  MODEL_LIST_PCBE,
  MODEL_LIST_SWITCHED_B10K,
  CABLETRAY_OPT_NO,
  HPE_GREENLAKE_CLOUD_PLATFORM,
  MODEL_ALLETRAMP,
} from '../../constants';
import { getOptInfo } from '../../config/productsConfig';

export default function PageOptSelector(props) {
  const {
    location,
    history,
    product,
    queryStringKey = 'opt',
    simplivityModelQueryStringKey = 'simplivitymodel',
    hpeAlletraDHCIModelQueryStringKey = 'hpeAlletraDHCImodel',
    modelQueryStringKey = 'model',
    connectQueryStringKey = 'connectopt',
    configureQueryStringKey = 'configureopt',
    cableTrayQueryStringKey = 'cabletray',
    greenlakePlatformQueryStringKey = 'greenlakeplatform',
    hypervisorQueryStringKey = 'hypervisoropt',
  } = props;
  const queryStringValues = getQueryStringValues(props.location);
  const opt = queryStringValues[queryStringKey];
  const model = queryStringValues[modelQueryStringKey];
  const simplivityModel = queryStringValues[simplivityModelQueryStringKey];
  const hpeAlletraDHCIModel =
    queryStringValues[hpeAlletraDHCIModelQueryStringKey];
  const connectOpt = queryStringValues[connectQueryStringKey];
  const configureOpt = queryStringValues[configureQueryStringKey];
  const cableTray = queryStringValues[cableTrayQueryStringKey];
  const greenlakePlatformOpt =
    queryStringValues[greenlakePlatformQueryStringKey];
  const hypervisorOpt = queryStringValues[hypervisorQueryStringKey];
  const productName = queryStringValues['product'];
  const onOptChange = (value) => {
    // const value = event.value.val;
    if (
      MODEL_LIST_SWITCHED_B10K.includes(model) &&
      value.option.val === PRIMERA_OPT_FIELD
    ) {
      ChangeQueryString(
        { cabletray: CABLETRAY_OPT_NO, opt: value.option.val },
        location,
        history,
      );
    } else {
      ChangeQueryString({ opt: value.option.val }, location, history);
    }
    // window.location.reload();
  };
  const onCableTrayOptChange = (value) => {
    ChangeQueryString({ cabletray: value.option.val }, location, history);
  };
  const onSimplivityModelOptChange = (value) => {
    ChangeQueryString({ simplivitymodel: value.option.val }, location, history);
  };
  const onHpeAlletraDHCIModelOptChange = (value) => {
    ChangeQueryString(
      { hpeAlletraDHCImodel: value.option.val },
      location,
      history,
    );
  };
  const onConnectOptChange = (value) => {
    ChangeQueryString({ connectopt: value.option.val }, location, history);
  };
  const onGreenlakePlatformOptChange = (value) => {
    ChangeQueryString(
      { greenlakeplatform: value.option.val },
      location,
      history,
    );
  };
  const onConfigureOptChange = (value) => {
    ChangeQueryString({ configureopt: value.option.val }, location, history);
  };
  const onHypervisorOptChange = (value) => {
    ChangeQueryString({ hypervisoropt: value.option.val }, location, history);
  };
  const {
    selectBoxLabel,
    options,
    selectedOptValue,
    simplivitySelectBoxLabel,
    simplivityOptions,
    selectBoxLabelforConnect,
    optionsForConnectConfig,
    selectBoxLabelforConfiguration,
    optionsForConfiguration,
    hpeAlletraDHCIOptions,
    selectBoxLabelForHPEAlletraDHCI,
    optionsForCableTray,
    selectBoxLabelforCableTray,
    optionsForGreenlakePlatform,
    selectBoxLabelforGreenlakePlatform,
    optionsForHypervisor,
    selectBoxLabelforHypervisor,
  } = getOptInfo({
    productId: product,
    opt,
    simplivityModel,
    hpeAlletraDHCIModel,
    greenlakePlatformOpt,
    hypervisorOpt,
  });
  if (options.length === 0 && product !== PRODUCT_ID_OAAS) {
    return null;
  }
  if (
    (product === PRODUCT_ID_ALLETRAB10K || product === PRODUCT_ID_OAAS) &&
    optionsForConnectConfig.length === 0
  ) {
    return null;
  }
  if (
    !selectedOptValue &&
    product !== PRODUCT_ID_ALLETRAB10K &&
    product !== PRODUCT_ID_OAAS
  ) {
    let _qsOpt = '';
    switch (product) {
      case PRODUCT_ID_DHCI:
      case PRODUCT_ID_PCBE:
        _qsOpt = DHCI_OPT_GREEN;
        break;
      case PRODUCT_ID_ALLETRA9k:
        _qsOpt = PRIMERA_OPT_FACTORY;
        break;
      case PRODUCT_ID_PRIMERA:
        _qsOpt = PRIMERA_OPT_FACTORY;
        break;
      case PRODUCT_ID_BAAS_9K_M:
        _qsOpt = PRIMERA_OPT_FIELD;
      default:
        break;
    }
    ChangeQueryString({ opt: _qsOpt }, props.location, props.history);
  }
  return (
    <>
      {productName !== PRODUCT_ID_FILE &&
        productName !== PRODUCT_ID_OAAS &&
        productName !== PRODUCT_ID_ALLETRAB10K &&
        model !== undefined &&
        model !== '' &&
        model !== HPE_SIMPLIVITY &&
        !MODEL_LIST_PCBE.includes(model) && (
          <Box
            width="medium"
            data-test-id="select-field"
            className="paddingBottom6"
          >
            <GenericSelect
              id="field-selector"
              label={selectBoxLabel}
              value={opt}
              onChange={onOptChange}
              options={options}
              errorMessage={props.installationErrMsg}
            />
          </Box>
        )}
      {productName === PRODUCT_ID_ALLETRAB10K && (
        <Box
          width="medium"
          data-test-id="select-field"
          className="paddingBottom6"
        >
          <GenericSelect
            id="field-selector"
            label={selectBoxLabel}
            value={opt}
            onChange={onOptChange}
            options={options}
            errorMessage={props.installationErrMsg}
          />
        </Box>
      )}
      {MODEL_LIST_SWITCHED_B10K.includes(model) &&
        opt === PRIMERA_OPT_FIELD && (
          <Box
            width="medium"
            data-test-id="select-field"
            className="paddingBottom6"
          >
            <GenericSelect
              id="field-selector"
              label={selectBoxLabelforCableTray}
              value={cableTray}
              onChange={onCableTrayOptChange}
              options={optionsForCableTray}
            />
          </Box>
        )}
      {productName === PRODUCT_ID_PCBE && MODEL_LIST_PCBE.includes(model) && (
        <Box
          width="medium"
          data-test-id="select-field"
          className="paddingBottom6"
        >
          <GenericSelect
            id="field-selector"
            label={selectBoxLabelForHPEAlletraDHCI}
            value={hpeAlletraDHCIModel}
            onChange={onHpeAlletraDHCIModelOptChange}
            options={hpeAlletraDHCIOptions}
            errorMessage={props.hpeAlletraDHCIModelErrMsg}
          />
        </Box>
      )}
      {productName === PRODUCT_ID_PCBE && model === HPE_SIMPLIVITY && (
        <Box
          width="medium"
          data-test-id="select-field"
          className="paddingBottom6"
        >
          <GenericSelect
            id="field-selector"
            label={simplivitySelectBoxLabel}
            value={simplivityModel}
            onChange={onSimplivityModelOptChange}
            options={simplivityOptions}
            errorMessage={props.simplivityModelErrMsg}
          />
        </Box>
      )}
      {productName === PRODUCT_ID_ALLETRAB10K && (
        <Box
          width="medium"
          data-test-id="select-field"
          className="paddingBottom6"
        >
          <GenericSelect
            id="field-selector"
            label={selectBoxLabelforGreenlakePlatform}
            value={greenlakePlatformOpt}
            onChange={onGreenlakePlatformOptChange}
            options={optionsForGreenlakePlatform}
            errorMessage={props.greenlakePlatformErrMsg}
          />
        </Box>
      )}
      {(greenlakePlatformOpt === HPE_GREENLAKE_CLOUD_PLATFORM ||
        productName === PRODUCT_ID_OAAS) &&
        productName !== PRODUCT_ID_FILE && (
          <Box
            width="medium"
            data-test-id="select-connect"
            className="paddingBottom6 marginBottom6"
          >
            <GenericSelect
              id="connect-selector"
              label={selectBoxLabelforConnect}
              value={connectOpt}
              onChange={onConnectOptChange}
              options={optionsForConnectConfig}
              errorMessage={props.connectionErrMsg}
            />
          </Box>
        )}
      {productName === PRODUCT_ID_PCBE && model === MODEL_ALLETRAMP && (
        <Box
          width="medium"
          data-test-id="select-field"
          className="paddingBottom6"
        >
          <GenericSelect
            id="field-selector"
            label={selectBoxLabelforHypervisor}
            value={hypervisorOpt}
            onChange={onHypervisorOptChange}
            options={optionsForHypervisor}
            errorMessage={props.hypervisorErrMsg}
          />
        </Box>
      )}
    </>
  );
}
